// import React from "react";
// import { usePermissions } from "context/PermissionsContext";

// import PropTypes from "prop-types";

// const stored_permissions = localStorage.getItem("user_permissions", []);
// const permissions = JSON.parse(stored_permissions);

// const WithPermission = ({ permission, children }) => {
//   if (permissions.includes(permission)) {
//     return children;
//   }

//   return null; // Or render an unauthorized message
// };

// WithPermission.propTypes = {
//   permission: PropTypes.string.isRequired, // Permission should be a string
//   children: PropTypes.node.isRequired, // Children can be any renderable React nodes
// };

// export default WithPermission;

// src/components/WithPermission.js
import React from "react";
import PropTypes from "prop-types";
import { usePermissions } from "context/PermissionsContext";

const WithPermission = ({ permission, children }) => {
  const { hasPermission } = usePermissions();

  return hasPermission(permission) ? children : null;
};

WithPermission.propTypes = {
  permission: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default WithPermission;
